import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const TitleSection = memo(({ theme, sectionId }) => {
  const TitleSectionLayout = dynamic(() => import(/* webpackChunkName: 'TitleSectionLayout' */ `../../../../../containers/home-page/views/sections/title/layouts/${theme.layout}`))

  return (
    <TitleSectionLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

TitleSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default TitleSection
